import { IconBarChartSteps } from '../../../../core';

// Every chart card draws the Data/bar-chart-steps icon, as the Data Viz pages do.
const CARD_ICON = <IconBarChartSteps />;

export const chartsMocks = [
  {
    id: 1,
    type: 'Lines',
    title: 'Area Chart',
    description: '',
    url: '/data-visualization/lines/area-chart',
    image: '/images/chart-match/01.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_trend',
      'dimensions_1dmn',
      'location_yes',
      'location_no',
      'moreThan12_yes',
      'moreThan12_no',
    ],
  },
  {
    id: 2,
    type: 'Lines',
    title: 'Area Chart - Stacked',
    description: '',
    url: '/data-visualization/lines/stacked-area-chart',
    image: '/images/chart-match/02.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_corr',
      'purpose_trend',
      'dimensions_1dmn',
      'location_yes',
      'location_no',
      'moreThan12_yes',
      'moreThan12_no',
    ],
  },
  {
    id: 3,
    type: 'Lines',
    title: 'Line chart',
    description: '',
    url: '/data-visualization/lines/line-chart',
    image: '/images/chart-match/03.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_trend',
      'dimensions_1d1n',
      'location_yes',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 4,
    type: 'Bars',
    title: 'Bar chart',
    description: '',
    url: '/data-visualization/bars/chart-v',
    image: '/images/chart-match/04.jpg',
    icon: CARD_ICON,
    types: ['purpose_corr', 'dimensions_1d1n', 'location_yes', 'location_no', 'moreThan12_no'],
  },
  {
    id: 5,
    type: 'Bars',
    title: 'Bar Chart - Grouped',
    description: '',
    url: '/data-visualization/bars/grouped-bar-chart-v',
    image: '/images/chart-match/05.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_md1n', 'location_yes', 'location_no', 'moreThan12_no'],
  },
  {
    id: 6,
    type: 'Bars',
    title: 'Bar Chart - Stacked',
    description: '',
    url: '/data-visualization/bars/stacked-bar-chart-v',
    image: '/images/chart-match/06.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_prop',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 7,
    type: 'Bars',
    title: 'Bar Chart - Horizontal Grouped',
    description: '',
    url: '/data-visualization/bars/grouped-bar-chart-h',
    image: '/images/chart-match/07.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_md1n', 'location_yes', 'location_no', 'moreThan12_yes'],
  },
  {
    id: 8,
    type: 'Bars',
    title: 'Bar Chart - Horizontal Stacked',
    description: '',
    url: '/data-visualization/bars/stacked-bar-chart-h',
    image: '/images/chart-match/08.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_prop',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_yes',
    ],
  },
  {
    id: 9,
    type: 'Bars',
    title: 'Funnel Chart',
    description: '',
    url: '/data-visualization/bars/funnel-chart',
    image: '/images/chart-match/09.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_prop',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_no',
      'moreThan12_yes',
      'moreThan12_no',
    ],
  },
  {
    id: 10,
    type: 'Bars',
    title: 'Histogram',
    description: '',
    url: '/data-visualization/bars/histogram',
    image: '/images/chart-match/10.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_corr',
      'purpose_dist',
      'purpose_trend',
      'dimensions_1d1n',
      'location_no',
      'moreThan12_yes',
      'moreThan12_no',
    ],
  },
  {
    id: 11,
    type: 'Bars',
    title: 'Lollipop',
    description: '',
    url: '/data-visualization/bars/lollipop-v',
    image: '/images/chart-match/11.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'dimensions_1d1n',
      'location_yes',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 12,
    type: 'Bars',
    title: 'Lollipop - Stacked',
    description: '',
    url: '/data-visualization/bars/stacked-lollipop-v',
    image: '/images/chart-match/12.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'purpose_prop',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 13,
    type: 'Bars',
    title: 'Lollipop - Horizontal',
    description: '',
    url: '/data-visualization/bars/lollipop-h',
    image: '/images/chart-match/13.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'dimensions_1d1n',
      'location_yes',
      'location_no',
      'moreThan12_yes',
    ],
  },

  {
    id: 14,
    type: 'Maps',
    title: 'Map - Choropleth',
    description: '',
    url: '/data-visualization/maps/choropleth',
    image: '/images/chart-match/14.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_1d1n', 'location_yes', 'moreThan12_yes'],
  },
  {
    id: 15,
    type: 'Maps',
    title: 'Map - Bubble',
    description: '',
    url: '/data-visualization/maps/bubble',
    image: '/images/chart-match/15.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_1d1n', 'location_yes', 'moreThan12_yes'],
  },
  {
    id: 16,
    type: 'Maps',
    title: 'Map - Spikes',
    description: '',
    url: '/data-visualization/maps/pikes',
    image: '/images/chart-match/16.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_1d1n', 'location_yes', 'moreThan12_yes'],
  },
  {
    id: 17,
    type: 'Maps',
    title: 'Map - Scatter',
    description: '',
    url: '/data-visualization/maps/scatter',
    image: '/images/chart-match/17.jpg',
    icon: CARD_ICON,
    types: ['purpose_corr', 'dimensions_1d1n', 'location_yes', 'moreThan12_yes'],
  },

  {
    id: 18,
    type: 'Tables',
    title: 'Heatmap',
    description: '',
    url: '/data-visualization/tables/heatmap',
    image: '/images/chart-match/18.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_yes',
    ],
  },
  {
    id: 19,
    type: 'Tables',
    title: 'Matrix',
    description: '',
    url: '/data-visualization/tables/matrix',
    image: '/images/chart-match/19.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_yes',
    ],
  },
  {
    id: 20,
    type: 'Tables',
    title: 'Punchcard',
    description: '',
    url: '/data-visualization/tables/punchcard',
    image: '/images/chart-match/20.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_yes',
    ],
  },

  {
    id: 21,
    type: 'Circulars',
    title: 'Donut Chart',
    description: '',
    url: '/data-visualization/circulars/donut',
    image: '/images/chart-match/21.jpg',
    icon: CARD_ICON,
    types: ['purpose_prop', 'dimensions_1d1n', 'location_no', 'moreThan12_no'],
  },
  {
    id: 22,
    type: 'Circulars',
    title: 'Polar Area Chart',
    description: '',
    url: '/data-visualization/circulars/polar',
    image: '/images/chart-match/22.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_1d1n', 'dimensions_md1n', 'location_no', 'moreThan12_no'],
  },
  {
    id: 23,
    type: 'Circulars',
    title: 'Radar Chart',
    description: '',
    url: '/data-visualization/circulars/radar',
    image: '/images/chart-match/23.jpg',
    icon: CARD_ICON,
    types: ['purpose_comp', 'dimensions_1d1n', 'dimensions_md1n', 'location_no', 'moreThan12_no'],
  },

  {
    id: 24,
    type: 'Diagrams',
    title: 'Treemap',
    description: '',
    url: '/data-visualization/diagrams/treemap',
    image: '/images/chart-match/24.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_prop',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 25,
    type: 'Diagrams',
    title: 'Circular Packing',
    description: '',
    url: '/data-visualization/diagrams/circle',
    image: '/images/chart-match/25.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_yes',
      'moreThan12_no',
    ],
  },
  {
    id: 26,
    type: 'Diagrams',
    title: 'Sankey Diagram',
    description: '',
    url: '/data-visualization/diagrams/sankey',
    image: '/images/chart-match/26.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_corr',
      'purpose_prop',
      'purpose_trend',
      'dimensions_md1n',
      'location_yes',
      'location_no',
      'moreThan12_no',
    ],
  },

  {
    id: 27,
    type: 'Others',
    title: 'Bubble Chart',
    description: '',
    url: '/data-visualization/others/bubble',
    image: '/images/chart-match/27.jpg',
    icon: CARD_ICON,
    types: ['purpose_corr', 'dimensions_1dmn', 'location_no', 'moreThan12_no'],
  },
  {
    id: 28,
    type: 'Others',
    title: 'Box Plot',
    description: '',
    url: '/data-visualization/others/box-plot-v',
    image: '/images/chart-match/28.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_dist',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 29,
    type: 'Others',
    title: 'Box Plot - Horizontal',
    description: '',
    url: '/data-visualization/others/box-plot-h',
    image: '/images/chart-match/29.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_dist',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_no',
      'moreThan12_yes',
    ],
  },
  {
    id: 30,
    type: 'Others',
    title: 'Line & Stacked Bar Chart',
    description: '',
    url: '/data-visualization/others/line-and-stacked-bar',
    image: '/images/chart-match/30.jpg',
    icon: CARD_ICON,
    types: ['purpose_prop', 'purpose_trend', 'dimensions_md1n', 'location_no', 'moreThan12_no'],
  },
  {
    id: 31,
    type: 'Others',
    title: 'Scatter Plot',
    description: '',
    url: '/data-visualization/others/scatter-plot',
    image: '/images/chart-match/31.jpg',
    icon: CARD_ICON,
    types: ['purpose_corr', 'dimensions_1dmn', 'location_no', 'moreThan12_no'],
  },
  {
    id: 32,
    type: 'Others',
    title: 'Violin Plot',
    description: '',
    url: '/data-visualization/others/violin-plot-v',
    image: '/images/chart-match/32.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_dist',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_no',
      'moreThan12_no',
    ],
  },
  {
    id: 33,
    type: 'Others',
    title: 'Violin Plot - Horizontal',
    description: '',
    url: '/data-visualization/others/violin-plot-h',
    image: '/images/chart-match/33.jpg',
    icon: CARD_ICON,
    types: [
      'purpose_comp',
      'purpose_dist',
      'dimensions_1d1n',
      'dimensions_md1n',
      'location_no',
      'moreThan12_yes',
    ],
  },
];
